// Kucuk zip okuyucu: tarayicinin DecompressionStream'i ile (bagimlilik yok).
// ponytail: zip64 ve sifreli zip desteklenmez; font paketleri icin yeterli.

export interface ZipEntry { name: string; data: Uint8Array<ArrayBuffer> }

async function inflateRaw(data: Uint8Array<ArrayBuffer>): Promise<Uint8Array<ArrayBuffer>> {
  const stream = new Blob([data]).stream().pipeThrough(new DecompressionStream("deflate-raw"));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

/** Zip icindeki dosyalari acar; `want` false donen girdiler hic acilmaz */
export async function unzip(buf: ArrayBuffer, want: (name: string) => boolean = () => true): Promise<ZipEntry[]> {
  const v = new DataView(buf);
  const bytes = new Uint8Array(buf);
  // Merkez dizin sonu kaydi (EOCD): sondan geriye ara (yorum en fazla 64 KB)
  let eocd = -1;
  for (let i = buf.byteLength - 22; i >= Math.max(0, buf.byteLength - 22 - 65535); i--) {
    if (v.getUint32(i, true) === 0x06054b50) { eocd = i; break; }
  }
  if (eocd < 0) throw new Error("Zip dosyası okunamadı");
  const count = v.getUint16(eocd + 10, true);
  let p = v.getUint32(eocd + 16, true);
  const dec = new TextDecoder();
  const out: ZipEntry[] = [];
  for (let n = 0; n < count; n++) {
    if (v.getUint32(p, true) !== 0x02014b50) throw new Error("Zip dosyası bozuk");
    const method = v.getUint16(p + 10, true);
    const size = v.getUint32(p + 20, true);
    const nameLen = v.getUint16(p + 28, true), extraLen = v.getUint16(p + 30, true), commentLen = v.getUint16(p + 32, true);
    const local = v.getUint32(p + 42, true);
    const name = dec.decode(bytes.subarray(p + 46, p + 46 + nameLen));
    p += 46 + nameLen + extraLen + commentLen;
    if (name.endsWith("/") || !want(name)) continue;
    const start = local + 30 + v.getUint16(local + 26, true) + v.getUint16(local + 28, true);
    const raw = bytes.subarray(start, start + size);
    if (method === 0) out.push({ name, data: raw });
    else if (method === 8) out.push({ name, data: await inflateRaw(raw) });
  }
  return out;
}
